import React, { useState, useEffect } from "react";
import { FaFacebookF, FaXTwitter, FaInstagram, FaLinkedinIn } from "react-icons/fa6";
import { useParams } from "react-router-dom";
import "../css/Footer.css";


const Footer = () => {
  const [openLinks, setOpenLinks] = useState(false)
  const [setlang, setLang] = useState("fa")
  const { lang } = useParams();
  
    useEffect (() => {
    const userTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    if(lang !== "fa" && lang !== "en") {
      if ( userTimezone === "Asia/Tehran") {
        setLang(`fa`);
      } else {
        setLang(`en`);
      }
    } else {
      setLang(lang)
    }
  }, [lang])

  return (
    <footer className="footer">
      <div className="footer-top" onMouseEnter={()=>setOpenLinks(true)} onMouseLeave={()=>setOpenLinks(false)}>
        {/* Multi-column links section */}
        <div className="footer-links">
          <div className="footer-column">
            <h4>BidZone</h4>
            {openLinks && 
            <ul>
              <li><a href={`/${setlang}/about`}>{setlang === "en" ? (<li>About Us</li>):(<li>درباره ما</li>)}</a></li>
              <li><a href={`/${setlang}/careers`}>{setlang === "en" ? (<li>Career</li>):(<li>کار با ما</li>)}</a></li>
              <li><a href={`/${setlang}/Community`}>{setlang === "en" ? (<li>Community</li>):(<li>فضای گفتگو</li>)}</a></li>
            </ul>
            }
          </div>
          <div className="footer-column">
            {setlang === "en" ? <h4>Platform</h4>:<h4>بازارگاه</h4>}
            {openLinks && 
            <ul>
              <li><a href={`/${setlang}/services`}>{setlang === "en" ? (<li>Services</li>):(<li>خدمات ما</li>)}</a></li>
            </ul>
            }
          </div>
          <div className="footer-column">
            {setlang === "en" ? <h4>Support</h4>:<h4>پشتیبانی</h4>}
            {openLinks && 
            <ul>
              <li><a href={`/${setlang}/help`}>{setlang === "en" ? (<li>FAQ</li>):(<li>راهنما</li>)}</a></li>
              <li><a href={`/${setlang}/our-terms-and-conditions`}>{setlang === "en" ? (<li>T&C</li>):(<li>شرایط و ضوابط</li>)}</a></li>
              <li><a href={`/${setlang}/our-privacy-policy`}>{setlang === "en" ? (<li>Privacy Policy</li>):(<li>محرمانگی اطلاعات</li>)}</a></li>
              <li><a href={`/${setlang}/our-return-policy`}>{setlang === "en" ? (<li>Return Policy</li>):(<li>بازگشت و استرداد</li>)}</a></li>
            </ul>
            }
          </div>
        </div>

        {/* Contact section */}
          <div className="footer-column" >
            {setlang === "en" ? <h4>Contact Us</h4>:<h4>تماس</h4>}
            {openLinks && 
            <ul>
              <li><a href={`/${setlang}/contact`}>{setlang === "en" ? (<li>Contact Support</li>):(<li>تماس با ما</li>)}</a></li>
              <li><a>support@bidzone.ir</a></li>
            </ul>
            }
          </div>

        {/* Social & external links */}
        <div className="footer-social">
          {setlang === "en" ? <h4>Follow Us</h4>:<h4>همراهی با ما</h4>}
          {openLinks && 
          <div className="social-icons">
            <a href="https://twitter.com" target="_blank" rel="noopener noreferrer">
              <FaXTwitter />
            </a>
            <a href="https://instagram.com" target="_blank" rel="noopener noreferrer">
              <FaInstagram />
            </a>
            <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer">
              <FaLinkedinIn />
            </a>
          </div>
          }
        </div>
      </div>

      {/* Bottom copyright */}
      <div className="footer-bottom">
        <p>© {new Date().getFullYear()} BidZone. All rights reserved.</p>
      </div>
    </footer>
  );
};

export default Footer;